import { useState } from 'react';
import './Match.scss';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import Footer from '../../../components/Footer/Footer';
import axios from 'axios';
import JyotishLinks from '../../../components/JyotishLinks/JyotishLink';
import { Link } from 'react-router-dom';
import cityData from '../../../city.json'; // adjust path

const Match = () => {


  const [cityBoySuggestions, setBoyCitySuggestions] = useState([]);
    const [cityGirlSuggestions, setGirlCitySuggestions] = useState([]);

  //for boy location dropdown
  const handleBoyCityChange = (value) => {
    handleBoyChange('city', value);


    if (value.trim() === "") {
      setBoyCitySuggestions([]);
      return;
    }
  
    // match cities starting with the typed value
    const filtered = cityData.filter(c =>
      c.city.toLowerCase().startsWith(value.toLowerCase())
    );
  
    setBoyCitySuggestions(filtered.slice(0, 4)); // only top 4
  };
  
  const handleBoySelectCity = (cityName) => {
    handleBoyChange('city', cityName);

    setBoyCitySuggestions([]); // close suggestions
  };


  //for girl location dropdown

    const handleGirlCityChange = (value) => {
    handleGirlChange('city', value);


    if (value.trim() === "") {
      setGirlCitySuggestions([]);
      return;
    }
  
    // match cities starting with the typed value
    const filtered = cityData.filter(c =>
      c.city.toLowerCase().startsWith(value.toLowerCase())
    );
  
    setGirlCitySuggestions(filtered.slice(0, 4)); // only top 4
  };
  
  const handleGirlSelectCity = (cityName) => {
    handleGirlChange('city', cityName);

    setGirlCitySuggestions([]); // close suggestions
  };


  const [boyData, setBoyData] = useState({
    name: '',
    birthMonth: 'July',
    birthDay: '7',
    birthYear: '2025',
    birthHour: '4',
    birthMinute: '24',
    birthSecond: '46',
    birthMeridiem: 'PM',
    city: ''
  });

  const [girlData, setGirlData] = useState({
    name: '',
    birthMonth: 'July',
    birthDay: '7',
    birthYear: '2025',
    birthHour: '4',
    birthMinute: '24',
    birthSecond: '46',
    birthMeridiem: 'PM',
    city: ''
  });

  const [showPopup, setShowPopup] = useState(false);
  const [resultData, setResultData] = useState(null);

  const handleBoyChange = (field, value) => {
    setBoyData(prev => ({ ...prev, [field]: value }));
  };

  const handleGirlChange = (field, value) => {
    setGirlData(prev => ({ ...prev, [field]: value }));
  };

  // const convertTo24Hour = (hour, meridiem) => {
  //   const h = Number(hour);
  //   if (meridiem === 'AM') return h === 12 ? 0 : h;
  //   return h === 12 ? 12 : h + 12;
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

  
       
        const city= boyData.city

        const monthNames = {
        January: '01',
        February: '02',
        March: '03',
        April: '04',
        May: '05',
        June: '06',
        July: '07',
        August: '08',
        September: '09',
        October: '10',
        November: '11',
        December: '12',
      };

        const formattedDate = `${boyData.birthYear}-${monthNames[boyData.birthMonth]}-${String(boyData.birthDay).padStart(2, '0')}`;

        const hour = String(boyData.birthHour).padStart(2, '0');
        const minute = String(boyData.birthMinute).padStart(2, '0');
        const formattedTime = `${hour}:${minute}`;
    
       
        const gcity= girlData.city
        const gformattedDate = `${girlData.birthYear}-${monthNames[girlData.birthMonth]}-${String(girlData.birthDay).padStart(2, '0')}`
        const ghour = String(girlData.birthHour).padStart(2, '0');
        const gminute = String(girlData.birthMinute).padStart(2, '0');
        const gformattedTime = `${ghour}:${gminute}`;
    

  
    try {
      const response = await axios.get(`https://core-c343.onrender.com/api/match?maleDate=${formattedDate}&maleTime=${formattedTime}&maleLocation=${city}&femaleDate=${gformattedDate}&femaleTime=${gformattedTime}&femaleLocation=${gcity}`);
      setResultData(response.data);
      setShowPopup(true);
    } catch (error) {
      console.error("API error:", error);
      alert("Something went wrong.");
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="Match-container">
      <InnerNav />
      <div className="Match-content">
        <Zodiac />
        <div className="horoscope-form-container">
          <div className="form-title">Birth Details for Horoscope Match</div>

          <form onSubmit={handleSubmit}>
            <div className="form-pair">
              {/* Boy's Section */}
              <div className="form-section">
                <h3>Boy's Details</h3>
                <div className="form-group">
                  <label>👤 Name</label>
                  <input type="text" value={boyData.name} onChange={(e) => handleBoyChange('name', e.target.value)} required />
                </div>

                <div className="form-group">
                  <label>📅 Birth Date</label>
                  <div className="select-row">
                    <select value={boyData.birthMonth} onChange={(e) => handleBoyChange('birthMonth', e.target.value)}>
                      {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map(month => (
                        <option key={month} value={month}>{month}</option>
                      ))}
                    </select>
                    <select value={boyData.birthDay} onChange={(e) => handleBoyChange('birthDay', e.target.value)}>
                      {Array.from({ length: 31 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                      ))}
                    </select>
                    <select value={boyData.birthYear} onChange={(e) => handleBoyChange('birthYear', e.target.value)}>
                      {Array.from({ length: 201 }, (_, i) => {
                        const year = 2025 - 100 + i;
                        return <option key={year} value={year}>{year}</option>;
                      })}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>⏰ Birth Time (24 hour format)</label>
                  <div className="select-row">
                    <select value={boyData.birthHour} onChange={(e) => handleBoyChange('birthHour', e.target.value)}>
                      {Array.from({ length: 24 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                      ))}
                    </select>
                    <select value={boyData.birthMinute} onChange={(e) => handleBoyChange('birthMinute', e.target.value)}>
                      {Array.from({ length: 60 }, (_, i) => (
                        <option key={i} value={i}>{i}</option>
                      ))}
                    </select>
                    <select value={boyData.birthSecond} onChange={(e) => handleBoyChange('birthSecond', e.target.value)}>
                      {Array.from({ length: 60 }, (_, i) => (
                        <option key={i} value={i}>{i}</option>
                      ))}
                    </select>
                    {/* <select value={boyData.birthMeridiem} onChange={(e) => handleBoyChange('birthMeridiem', e.target.value)}>
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select> */}
                  </div>
                </div>
                <div className="form-group">
                  <label>📍 Birth City</label>
                  <input
                    type="text"
                    value={boyData.city}
                    placeholder="Enter City"
                    onChange={(e) => handleBoyCityChange(e.target.value)}
                    required
                  />
                    {cityBoySuggestions.length > 0 && (
                      <ul className="suggestion-list">
                        {cityBoySuggestions.map((c, idx) => (
                          <li
                            key={idx}
                            onClick={() => handleBoySelectCity(c.city)}
                          >
                            {c.city}, {c.state}, {c.country}
                          </li>
                        ))}
                      </ul>
                    )}
                </div>
              </div>

              {/* Girl's Section */}
              <div className="form-section">
                <h3>Girl's Details</h3>
                <div className="form-group">
                  <label>👤 Name</label>
                  <input type="text" value={girlData.name} onChange={(e) => handleGirlChange('name', e.target.value)} required />
                </div>
                <div className="form-group">
                  <label>📅 Birth Date</label>
                  <div className="select-row">
                    <select value={girlData.birthMonth} onChange={(e) => handleGirlChange('birthMonth', e.target.value)}>
                      {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map(month => (
                        <option key={month} value={month}>{month}</option>
                      ))}
                    </select>
                    <select value={girlData.birthDay} onChange={(e) => handleGirlChange('birthDay', e.target.value)}>
                      {Array.from({ length: 31 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                      ))}
                    </select>
                    <select value={girlData.birthYear} onChange={(e) => handleGirlChange('birthYear', e.target.value)}>
                      {Array.from({ length: 201 }, (_, i) => {
                        const year = 2025 - 100 + i;
                        return <option key={year} value={year}>{year}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>⏰ Birth Time (24 hour format)</label>
                  <div className="select-row">
                    <select value={girlData.birthHour} onChange={(e) => handleGirlChange('birthHour', e.target.value)}>
                      {Array.from({ length: 24 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                      ))}
                    </select>
                    <select value={girlData.birthMinute} onChange={(e) => handleGirlChange('birthMinute', e.target.value)}>
                      {Array.from({ length: 60 }, (_, i) => (
                        <option key={i} value={i}>{i}</option>
                      ))}
                    </select>
                    <select value={girlData.birthSecond} onChange={(e) => handleGirlChange('birthSecond', e.target.value)}>
                      {Array.from({ length: 60 }, (_, i) => (
                        <option key={i} value={i}>{i}</option>
                      ))}
                    </select>
                    {/* <select value={girlData.birthMeridiem} onChange={(e) => handleGirlChange('birthMeridiem', e.target.value)}>
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select> */}
                  </div>
                </div>
                <div className="form-group">
                  <label>📍 Birth City</label>
                  <input
                    type="text"
                    value={girlData.city}
                    placeholder="Enter City"
                    onChange={(e) => handleGirlCityChange(e.target.value)}
                    required
                  />
                    {cityGirlSuggestions.length > 0 && (
                      <ul className="suggestion-list">
                        {cityGirlSuggestions.map((c, idx) => (
                          <li
                            key={idx}
                            onClick={() => handleGirlSelectCity(c.city)}
                          >
                            {c.city}, {c.state}, {c.country}
                          </li>
                        ))}
                      </ul>
                    )}
                </div>              
                </div>
            </div>

            <div className="form-actions">
              <button type="button" className="clear-btn" onClick={() => {
                setBoyData({ name: '', birthMonth: 'July', birthDay: '7', birthYear: '2025', birthHour: '4', birthMinute: '24', birthSecond: '46', birthMeridiem: 'PM', city: '' });
                setGirlData({ name: '', birthMonth: 'July', birthDay: '7', birthYear: '2025', birthHour: '4', birthMinute: '24', birthSecond: '46', birthMeridiem: 'PM', city: '' });
              }}>CLEAR</button>
              <button type="submit" className="submit-btn">SUBMIT</button>
            </div>
          </form>

          {showPopup && resultData && (
          <div className="popup-overlay">
            <div className="popup-content">
              <div className="popup-body">
                <h2>Horoscope Match Result</h2>

                <div className="person-details">
                  <p><strong>Male Name:</strong> {boyData.name}</p>
                  <p><strong>Female Name:</strong> {girlData.name}</p>

                  <h3>🧍‍♂️ Male Details</h3>
                  <p><strong>Nakshatra:</strong> {resultData?.male?.nakshatra}</p>
                  <p><strong>Rashi:</strong> {resultData?.male?.rashi}</p>

                  <h3>🧍‍♀️ Female Details</h3>
                  <p><strong>Nakshatra:</strong> {resultData?.female?.nakshatra}</p>
                  <p><strong>Rashi:</strong> {resultData?.female?.rashi}</p>
                </div>

                <div className="matching-details">
                  <h3>💑 Matching Details</h3>

                  <div className="matching-item">
                    <p><strong>Varna (Compatibility):</strong> {resultData?.matching?.varna}</p>
                    <small>Varna refers to the mental compatibility of the two persons involved. It holds minimal effect in the matters of marriage compatibility.</small>
                  </div>

                  <div className="matching-item">
                    <p><strong>Vashya (Dominance):</strong> {resultData?.matching?.vashya}</p>
                    <small>Vashya indicates the bride and groom's tendency to dominate or influence each other in marriage.</small>
                  </div>

                  <div className="matching-item">
                    <p><strong>Tara (Destiny):</strong> {resultData?.matching?.tara}</p>
                    <small>Tara is the indicator of the birth star compatibility and the fortune of the couple.</small>
                  </div>

                  <div className="matching-item">
                    <p><strong>Yoni (Physical Compatibility):</strong> {resultData?.matching?.yoni}</p>
                    <small>Yoni shows the sexual or physical compatibility between the bride and groom.</small>
                  </div>

                  <div className="matching-item">
                    <p><strong>Graha Maitri (Mental Compatibility):</strong> {resultData?.matching?.grahaMaitri}</p>
                    <small>Maitri assesses mutual love, understanding, and mental compatibility of the couple.</small>
                  </div>

                  <div className="matching-item">
                    <p><strong>Gana (Temperament):</strong> {resultData?.matching?.gana}</p>
                    <small>Gana indicates the behavior, character, and temperament of the couple towards each other.</small>
                  </div>

                  <div className="matching-item">
                    <p><strong>Bhakoot (Love):</strong> {resultData?.matching?.bhakoot}</p>
                    <small>Bhakoot is related to joy, sorrow, and harmony after marriage. It impacts health and bonding.</small>
                  </div>

                  <div className="matching-item">
                    <p><strong>Nadi (Health):</strong> {resultData?.matching?.nadi}</p>
                    <small>Nadi is linked to genetic compatibility, childbirth prospects, and overall health after marriage.</small>
                  </div>

                  <hr />

                  <p className="total-score"><strong>Total Score:</strong> {resultData?.matching?.totalScore}/{resultData?.matching?.maxScore}</p>

                  <p>--To know more please click below--</p>
                  <Link to='/#contact'>
                  <button> Talk to the Astrologer</button>
                  </Link>
                </div>

                <button className="close-btn" onClick={handleClosePopup}>Close</button>
              </div>
            </div>
          </div>

          )}
        </div>
        <JyotishLinks/>
      </div>
      <Footer />
    </div>
  );
};

export default Match;
